import { createSeoFriendlySlug } from './urlHelpers';
import { createEmptyForumForm } from './forumFormDefaults';

export type SuggestionPrefillPayload = {
  suggestionId: string;
  name: string;
  url: string;
  category: string;
  software: string;
  description: string;
  forum_id: string;
};

/** AddForum / eski kayıtlar: "Öneren: X\n\naçıklama" */
export function parseSuggestionDescription(raw: string | null | undefined): {
  submitter: string;
  body: string;
} {
  if (!raw?.trim()) return { submitter: '', body: '' };
  const m = raw.match(/^Öneren:\s*(.+?)(?:\n\n([\s\S]*))?$/);
  if (m) {
    return { submitter: (m[1] || '').trim(), body: (m[2] || '').trim() };
  }
  return { submitter: '', body: raw.trim() };
}

export function buildSuggestionPrefill(suggestion: {
  id: string;
  name: string;
  url?: string | null;
  software?: string | null;
  description?: string | null;
  category?: { name: string } | null;
  category_legacy?: string | null;
}): SuggestionPrefillPayload {
  const categoryName = suggestion.category?.name || suggestion.category_legacy || '';
  const { body } = parseSuggestionDescription(suggestion.description);
  const baseSlug = createSeoFriendlySlug(suggestion.name);

  return {
    suggestionId: suggestion.id,
    name: suggestion.name,
    url: suggestion.url || '',
    category: categoryName,
    software: suggestion.software || '',
    description: body,
    forum_id: baseSlug,
  };
}

export function suggestionPrefillToForumForm(prefill: SuggestionPrefillPayload) {
  return {
    ...createEmptyForumForm(),
    forum_id: prefill.forum_id,
    name: prefill.name,
    category: prefill.category,
    url: prefill.url,
    description: prefill.description,
    software: prefill.software,
  };
}
